module.exports = "/v8.50.1/1e86e9e/bundles/opensearch.xml";